import * as React from "react";
import {getFirstInstalmentDueDate, getAmountToDisplay} from "@falcon/plugin-falcon-journey";
import DirectDebitPaymentSchedule from "../../../../../components/widgets/DirectDebitPaymentSchedule";

interface IProps {
    interaction: any,
}

interface IState {
    isOpen: boolean;
}

export class DirectDebitRenewalPaymentPlanOutput extends React.Component <IProps, IState> {

    constructor(props: IProps) {
        super(props)

        this.state = {
            isOpen: false
        };
    }

    public render() {
        return (
            <div className="text-center mt-4 payment-day-section payment-details-section grid-col-1-2
                            icon-calendar-checked-before column-height-100-width-667">
                <div className="bubble-container">
                    <div className="corner-bubble">Renewal only</div>
                </div>
                <div className="dashboard-panel-title my-3">Payment schedule</div>
                {this.renderContent()}
            </div>
        )
    }

    private renderContent = (): React.JSX.Element => {
        const interaction = this.props.interaction
        const instalment = interaction.paymentDetails.instalmentPlan.instalments[1];
        const amount = instalment.principal + instalment.interest;
        const paymentDate: string = getFirstInstalmentDueDate(interaction).format("Do MMMM YYYY");

        return (
            <div className="mt-3 margin-top-0 grid-col-2">
                <div className="banner banner-info">
                    <p>
                        Your first instalment will come out on <span
                        className="font-weight-bold">{paymentDate}</span> and
                        on this day in future months. You can also change your payment day later on in your account.
                    </p>
                </div>
                <p>
                    Below is a list of dates when we'll collect the payments
                    (if your preferred payment date falls on a weekend or Bank Holiday,
                    we'll take the payment on the next closest week day).
                    You have {this.props.interaction.paymentDetails.instalmentPlan.instalments.length}
                    <span className="font-weight-semi-bold"> instalments of {getAmountToDisplay(amount)}</span>
                </p>
                <div className="mb-3">
                    <DirectDebitPaymentSchedule
                        isOpen={this.state.isOpen}
                        instalments={this.props.interaction.paymentDetails.instalmentPlan.instalments || []}
                        interaction={this.props.interaction}
                        instalmentDueDates={true}
                    />
                </div>
                <div className="text-center">
                    {!this.state?.isOpen ?
                        <button className="direct-debit-btn-text text-center cursor-pointer"
                                onClick={this.toggleInstallmentPlan}>
                            + <span className="text-decoration-underline">View payment plan</span>
                        </button>
                        :
                        <button className="direct-debit-btn-text text-center cursor-pointer"
                                onClick={this.toggleInstallmentPlan}>
                            - <span className="text-decoration-underline">Hide payment plan</span>
                        </button>}
                </div>
            </div>
        )
    }

    private toggleInstallmentPlan: () => void = (): void => {
        this.setState((prevState: Readonly<IState>): { isOpen: boolean } => ({
            isOpen: !prevState.isOpen
        }));
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/DirectDebitRenewalPaymentPlanOutput.tsx